import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Bug } from "lucide-react";
import "./ReportBugButton.css";

const ReportBugButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Hide on study pages
  const hideOnPaths = [
    "/myspace",
    "/study/notes",
    "/study/flashcards",
  ];

  const hideOnPathPatterns = [
    /^\/public\/notes\//,
    /^\/public\/flashcards\//,
    /^\/view\/lesson\//,
    /^\/shared\//,
  ];

  // Hide when in notes or flashcards mode (URL params)
  const searchParams = new URLSearchParams(location.search);
  const hasNotesMode = searchParams.get('takeNotes') === 'true' || searchParams.get('openTakeNotes') === 'true';
  const hasFlashcardsMode = searchParams.get('flashcards') === 'true' || searchParams.get('openFlashcards') === 'true';

  if (hideOnPaths.includes(location.pathname) || hideOnPathPatterns.some(pattern => pattern.test(location.pathname)) || hasNotesMode || hasFlashcardsMode) {
    return null;
  }

  const handleClick = () => {
    navigate("/contact?subject=Bug Report");
  };

  return (
    <button
      className="report-bug-button"
      onClick={handleClick}
      title="Report Bug"
    >
      <Bug size={20} />
    </button>
  );
};

export default ReportBugButton;
